<template>
    <div class="orderSummary--flowers">
        <p>{{label}}</p>
        <div class="orderSummary--amount">
            <p class="orderSummary--amount--text" :class="{ 'strikeThrough': strike }">{{actualAmountText}}</p>
            <p class="orderSummary--amount--text" v-if="strike">{{`${currencySymbol}${payableAmount}`}}</p>
        </div>
    </div>
</template>

<script>
import countries from '@/resources/countries.json';

export default {
    name: 'OrderSummaryLabel',
    props: {
        label: {
            type: String,
        },
        hasCoupon: {
            default: false,
        },
        actualAmount: {
            default: 0,
        },
        payableAmount: {
            default: 0,
        },
        alternateText: {
            type: String,
        },
    },
    computed: {
        currencySymbol() {
            const country = countries.filter(item => item.iso.toUpperCase() === process.env.VUE_APP_COUNTRY_ISO.toUpperCase());
            return country[0].currency.symbol;
        },
        actualAmountText() {
            return this.actualAmount ? `${this.currencySymbol}${this.actualAmount}` : this.alternateText;
        },
        strike() {
            return this.hasCoupon && (this.actualAmount !== this.payableAmount);
        },
    },
};
</script>

<style lang="scss" scoped>
.orderSummary{
    max-width: 400px;
    margin: 2rem auto;
    padding: 0 1rem;
    &--flowers {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 1rem auto;
        margin-bottom: 0;
        p {
            font-size: 20px;
            margin: 0;
        }
    }
    &--amount {
        display: flex;
        align-items: center;
        &--text {
            margin: 0 0.25rem;
            font-size: 20px;
            text-align: right;
            font-weight: 400;
            color: theme('colors.shop.black');
        }
        &--text.strikeThrough {
            margin: 0 0.5rem;
            text-decoration: line-through;
            color: theme('colors.shop.darkgrey');
            font-size: 17px;
            font-weight: lighter;
            line-height: 22px;
        }
    }
}
</style>
